import { createUseStyles } from 'react-jss';
import UploadImage from '../../assets/Upload.svg';

export default createUseStyles(
  {
    root: {
      position: 'relative',
      width: '32px',
      height: '32px',
      margin: 0,
      padding: 0,
    },

    uploadIcon: {
      position: 'absolute',
      left: '25%',
      right: '25%',
      top: '25%',
      bottom: '25%',
      backgroundImage: `url(${UploadImage})`,
    },
  },
  {
    name: 'UploadIcon',
  },
);
